import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/fixed-distributions');
export const getByCaseId = (caseId) => req('GET', `/by-case/${caseId}`);
export const getByFromCaseVoucherId = (fromCaseVoucherId) => req('GET', `/by-case-voucher/${fromCaseVoucherId}`);
export const create = (fromCaseVoucherId, input) => req('POST', `/by-case-voucher/${fromCaseVoucherId}`, { body: input });
export const update = (id, input) => req('PATCH', `/${id}`, { body: input });
export const del = (id) => req('DELETE', `/${id}`);
export const batch = (fromCaseVoucherId, input) => req('PATCH', `/by-case-voucher/${fromCaseVoucherId}/batch`, { body: input });
//# sourceMappingURL=fixed-distributions.js.map